import {
    SYNC_USERS_LOADING,
    SYNC_USERS_SUCCESS,
    SYNC_USERS_ERROR
} from '../actions/types';

const initialState = {
    syncing: false,
    syncError: null,
    users: [],
    loading: false,
    error: null,
};

export default function syncUsersReducer(state = initialState, action) {
    switch (action.type) {
        case SYNC_USERS_LOADING:
            return { ...state, syncing: true, syncError: null };
        case SYNC_USERS_SUCCESS:
            return { ...state, syncing: false, syncError: null };
        case SYNC_USERS_ERROR:
            return { ...state, syncing: false, syncError: action.payload };

        case 'GET_USER_LOADING':
            return { ...state, loading: true, error: null };
        case 'GET_USER_SUCCESS':
            return { ...state, loading: false, users: action.payload.items || action.payload, error: null };
        case 'GET_USER_FAILURE':
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
}
